import { useEffect, useState } from 'react';

// What's been typed into a form, kept on the phone as it's typed, so a
// refresh, the app being closed or the phone killing it in the background
// doesn't lose it. Cleared once the form is sent. One draft per `key` (the
// count's week; the order being changed, or a new one).
const read = (key) => {
  try { return JSON.parse(localStorage.getItem(key)) || {}; } catch { return {}; }
};

export function useDraft(key) {
  const [draft, setDraft] = useState(() => read(key));
  useEffect(() => { setDraft(read(key)); }, [key]);
  const update = (patch) => setDraft((prev) => {
    const next = { ...prev, ...patch };
    try { localStorage.setItem(key, JSON.stringify(next)); } catch { /* kept for this visit */ }
    return next;
  });
  const clear = () => {
    try { localStorage.removeItem(key); } catch { /* nothing to clear */ }
    setDraft({});
  };
  return [draft, update, clear];
}

// One field of a draft, used like useState: [value, setValue].
export const draftField = (draft, save, name, initial) => [draft[name] ?? initial, (v) => save({ [name]: v })];
